import { Fancybox } from "@fancyapps/ui";

document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.js-section-dashboard-block');

    sections.forEach((section) => {
        const buttons = section.querySelectorAll('.js-section-dashboard-block-button');
        const chartImage = section.querySelector('.js-section-dashboard-block-image');
        const caption = section.querySelector('.js-section-dashboard-block-caption');
        const indicator = section.querySelector('.js-section-dashboard-block-indicator');
        const select = section.querySelector('.js-section-dashboard-block-select');

        buttons.forEach((button, index) => {
            button.addEventListener('click', function () {
                chartImage.src = button.dataset.image;
                chartImage.setAttribute('data-caption', button.dataset.caption); // Dodano dla Fancybox
                buttons.forEach(btn => btn.classList.remove('section-dashboard-block__button--active'));
                button.classList.add('section-dashboard-block__button--active');
                indicator.style.left = `${button.offsetLeft + button.offsetWidth / 2}px`;
            });
        });

        if (select) {
            select.addEventListener('change', function () {
                const selectedIndex = select.value;
                const selectedOption = select.options[selectedIndex];
                chartImage.src = selectedOption.dataset.image;
                chartImage.setAttribute('data-caption', selectedOption.dataset.caption); // Dodano dla Fancybox
                indicator.style.left = `${buttons[selectedIndex].offsetLeft + buttons[selectedIndex].offsetWidth / 2}px`;
            });
        }

        const initialButton = section.querySelector('.js-section-dashboard-block-button.section-dashboard-block__button--active') || buttons[0];
        if (initialButton) {
            initialButton.classList.add('section-dashboard-block__button--active');
            indicator.style.left = `${initialButton.offsetLeft + initialButton.offsetWidth / 2}px`;
        }

        window.addEventListener('resize', function () {
            const activeButton = section.querySelector('.section-dashboard-block__button--active');
            if (activeButton) {
                indicator.style.left = `${activeButton.offsetLeft + activeButton.offsetWidth / 2}px`;
            }
        });
    });

    // Inicjalizacja Fancybox dla obrazka
    Fancybox.bind(".js-section-dashboard-block-image", {
        caption: (fancybox, slide) => {
            return slide.$trigger ? slide.$trigger.dataset.caption || "" : "";
        }
    });
});